import withInitStateReducerEnhancer from '@Utils/Redux/withInitStateReducerEnhancer';
import { getCurrentSettingsFromAppStorage } from '@Pages/Heatmap/HeatmapSettingsStorage';
import {
  SET_HEATMAP_OPEN,
  SET_SETTINGS,
  FETCH_HEATMAP_DATA,
  FETCH_HEATMAP_DATA_SUCCESS,
  FETCH_HEATMAP_DATA_FAILURE,
  UPDATE_HEATMAP_DATA,
  SET_SELECTION_INFO,
} from './constants';

export const initialState = {
  open: false,
  heatmapDataImprint: null,
  heatmapData: null,
  matrixReceived: false,
  navigatorDisabled: false,
  selectionInfo: null,
  settings: null,
};

export const initState = () => {
  return {
    ...initialState,
    settings: getCurrentSettingsFromAppStorage(),
  };
};

// eslint-disable-next-line default-param-last
const reducer = withInitStateReducerEnhancer((state, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_HEATMAP_OPEN:
      return {
        ...state,
        open: payload,
      };
    case SET_SETTINGS:
      return {
        ...state,
        settings: payload,
      };
    case FETCH_HEATMAP_DATA: {
      return {
        ...state,
        heatmapData: null,
        matrixReceived: false,
        navigatorDisabled: false,
        heatmapDataImprint: payload,
      };
    }
    case FETCH_HEATMAP_DATA_SUCCESS:
      return {
        ...state,
        heatmapData: payload,
        matrixReceived: true,
      };
    case FETCH_HEATMAP_DATA_FAILURE:
      return {
        ...state,
        matrixReceived: false,
      };
    case UPDATE_HEATMAP_DATA:
      return {
        ...state,
        heatmapData: payload,
      };
    case SET_SELECTION_INFO:
      return {
        ...state,
        selectionInfo: payload,
      };
    default: {
      return state;
    }
  }
}, initState);

export default reducer;
